<form [formGroup]="profileForm">

    <app-investor-preference-section *ngIf="shouldShowPreferenceSection"
        [preferenceForm]="profileForm"
        [eventInfoWithConsent]="eventInfoWithConsent">
    </app-investor-preference-section>

    <app-investor-profile-section
        [profileForm]="profileForm"
        [lastEmail]="savedEmail"
        [eventInfoWithConsent]="eventInfoWithConsent"
        [eventAlias]="eventInfoWithConsent.eventAlias"
        [companies]="companies"
        [countries]="countries">
    </app-investor-profile-section>

    <app-investor-assistant-section 
        [assistantForm]="profileForm">
    </app-investor-assistant-section>

    <div class="d-flex justify-content-end">
        <button class="btn btn-primary" (click)="onSubmit()" [disabled]="profileForm.invalid || isClosedRegis">Save</button>
    </div>

</form>